<r-widget-control [control]="firstnameControl">
  <nz-checkbox-group
    [name]="config.name"
    [(ngModel)]="config.dataSource"
    (ngModelChange)="onChange($event)"
    [required]="config.required"
    [disabled]="config.disabled"
    ngDefaultControl
    #firstnameControl="ngModel"
  >
  </nz-checkbox-group>
</r-widget-control>
